// Single source of truth for the per-video status (VideoStatus 0/1/2) shown
// across the Video Interaction panel. Used both on the course list
// (VideoDashboardPage) and on the per-course video list (Dashboard).
export const VIDEO_STATUS_DEFINITIONS = [
  { value: 0, label: "Değerlendirme Bekliyor", color: "#5b21b6", dot: "#7c3aed" },
  { value: 1, label: "Video Onay",              color: "#065f46", dot: "#10b981" },
  { value: 2, label: "Video Düzenlenecek",      color: "#7f1d1d", dot: "#dc2626" },
];
